import React from 'react';
import {ReactComponent as ArrowDownIcon} from './round-arrow_drop_down.svg';
import {format} from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import enLocale from 'date-fns/locale/en-GB';
import {useTranslation} from "react-i18next";
import DatePicker from "react-datepicker";

interface ThemedCalendarProps {
    callback: (d: Date) => void
    selectedDate: Date
    disabled?: boolean
    minDate?: Date
}

export const ThemedCalendar: React.FC<ThemedCalendarProps> = ({callback, selectedDate, disabled = false, minDate}) => {
    const dateNow = new Date();
    const {i18n} = useTranslation();
    const calendarLocale = i18n.language.slice(0, 2) === 'ru' ? ruLocale : enLocale;

    function handleDateChange(date: Date | null) {
        if (!date) {
            callback(dateNow);
            return
        }
        if (date > dateNow) {
            callback(dateNow)
        } else {
            callback(date)
        }
    }

    const DateInputButton = React.forwardRef<HTMLButtonElement, React.HTMLProps<HTMLButtonElement>>(
        ({value, onClick, className}, ref) => (
            <button
                className={"flex gap-[10px] items-center rounded-[29px] bg-[#171A1E] text-white p-0 h-[24px] text-[12px] pl-[10px] pr-[15px] tablet:text-[16px] tablet:h-[40px] tablet:pl-[20px] tablet:pr-[25px] tablet:w-[171px]"}
                onClick={onClick} ref={ref}>
                <ArrowDownIcon/>
                {typeof value === "string" ? format(new Date(value), 'd MMMM', {locale: calendarLocale}) : ""}
            </button>
        ),
    );

    return (
        <DatePicker
            selected={selectedDate}
            onSelect={handleDateChange}
            disabled={disabled}
            minDate={minDate}
            locale={calendarLocale}
            customInput={<DateInputButton/>}
        />
    );
};
